import { render, staticRenderFns } from "./Goodsdetail.vue?vue&type=template&id=1ad32144&scoped=true"
import script from "./Goodsdetail.vue?vue&type=script&lang=js"
export * from "./Goodsdetail.vue?vue&type=script&lang=js"
import style0 from "./Goodsdetail.vue?vue&type=style&index=0&id=1ad32144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad32144",
  null
  
)

export default component.exports